/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

//import {  Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IObrienHomeHero23ViewProps } from './obrien-home-hero23';

import { useRef, useEffect } from "react";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

//@ts-ignore
import { Link } from 'react-scroll';

export default (props: IObrienHomeHero23ViewProps) => {

    let animateThis1 = useRef(null);

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        gsap.to( animateThis1, {
            scrollTrigger: {
                trigger: '.ob-hero', 
                start: "top top",
                scrub: 1,
            },
            duration: 2,
            x: '0',
            y: '160',
            ease: "linear",
        })
        
    }, [])


    const { obHeroImage, obHeroTitle, obHeroId, obHeroContent, links, obHeroImageOverlay, obHeroButtonLink, obHeroButtonText} = props;
    return (
        <>

            <div className={`ob-hero ${obHeroId}`}>

                <div className="text-container">
                    <div>
                        
                            {obHeroImageOverlay ? (
                            <div className='heroImgOverlay'>{obHeroImageOverlay}</div>
                            ) : null}
                            {obHeroTitle ? (
                            <div>{obHeroTitle}</div>
                            ) : null}
                            {obHeroContent ? (
                            <div dangerouslySetInnerHTML={{ __html: obHeroContent }}></div>
                            ) : null}
                            {links ? (
                            <div className="around-button">
                                {links}
                            </div>
                            ) : null}
                            {obHeroButtonLink ? (
                            <div className="around-button">
                                <div className='ms-content-block__cta'>
                                    <Link to={obHeroButtonLink} spy={true} smooth={true} duration={500}>
                                        <span>{obHeroButtonText}</span>
                                    </Link>
                                </div>
                            </div>
                            ) : null}
                            
                        
                    </div>
                </div>
                
                <div className="hero-img-fix">
                    <div
                        ref={el => {
                        //@ts-ignore
                        animateThis1 = el}}
                    >
                        {obHeroImage}
                    </div>
                    <div className="overlay"></div>
                </div>

                
            </div>

    
    </>
    );
};
